import { Result, ok, err } from '@xlearn/common';

export enum CompletionStatus {
  unknown,
  completed,
  incomplete,
  notAttempted
}

export function statusToString(value: CompletionStatus): string {
  switch (value) {
    case CompletionStatus.unknown:
      return 'unknown';
    case CompletionStatus.notAttempted:
      return 'not attempted';
    case CompletionStatus.completed:
      return 'completed';
    case CompletionStatus.incomplete:
      return 'incomplete';
  }
}

export function parseStatus(value: string): Result<CompletionStatus, false> {
  switch (value) {
  case 'completed':
      return ok(CompletionStatus.completed);
  case 'incomplete':
      return ok(CompletionStatus.incomplete);
  case 'not attempted':
      return ok(CompletionStatus.notAttempted);
    case 'unknown':
      return ok(CompletionStatus.unknown);
  default:
      return err(false);
  }
}
